/* oxlint-disable no-restricted-imports */
import {
  createElement,
  useMemo,
  type AnchorHTMLAttributes,
  type ComponentType,
  type FC,
} from "react";
import { Remark, type RemarkProps } from "react-remark";

export interface MarkdownContentProps {
  remarkPlugins?: RemarkProps["remarkPlugins"];
  LinkComponent?: ComponentType<AnchorHTMLAttributes<HTMLElement>>;
  children: string;
}

const remarkToRehypeOptions: RemarkProps["remarkToRehypeOptions"] = {
  // TODO: Maybe also validate links?
  handlers: {
    image: (state, node, parent) => {
      // Don't render images
      // TODO: Allow rendering images on trusted domains and/or non-SVG images?
      return undefined;
    },
  },
};

/** Wrapper around `Remark` from `react-remark` with customizations for security. */
export const MarkdownContent: FC<MarkdownContentProps> = (props) => {
  const { LinkComponent } = props;

  const rehypeReactOptions: RemarkProps["rehypeReactOptions"] = useMemo(() => {
    if (!LinkComponent) {
      return undefined;
    }

    return {
      components: {
        a: (props: AnchorHTMLAttributes<HTMLElement>) =>
          createElement(LinkComponent, props),
      },
    };
  }, [LinkComponent]);

  return (
    <Remark
      remarkPlugins={props.remarkPlugins}
      remarkToRehypeOptions={remarkToRehypeOptions}
      rehypeReactOptions={rehypeReactOptions}
    >
      {props.children}
    </Remark>
  );
};
